import { Box, Typography } from "@mui/material";

const CustomEvaluationHeader = () => (
  <Box>
    <Typography variant="subtitle2" align="center">
      Evaluation
    </Typography>
    <Box display="flex" justifyContent="space-around" mt={0.5}>
      <Typography variant="caption">Pass</Typography>
      <Typography variant="caption">Fail</Typography>
    </Box>
  </Box>
);
export default CustomEvaluationHeader;
